import { useQuery } from '@tanstack/react-query';
import { fetchCollectMtrFile } from '@/integrations/mtrManager/client';

export function useCollectMtrFile(collectId: string | null) {
  return useQuery({
    queryKey: ['collect-mtr-file', collectId],
    queryFn: () => fetchCollectMtrFile(collectId!),
    enabled: !!collectId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
